<div class="content-body-aboutus px-2 pt-2">
    <!-- Knowledge base Jumbotron -->
    <section id="knowledge-base-search">
        <div class="row">
            <div class="col-12">
                <div class="card knowledge-base-bg text-center">
                    <div class="card-body">
                        <h1 class="text-light">
                            Find the next ALPHA within minutes using data science and analytics.
                        </h1>
                        <p class="card-text text-light mb-2">
                            <span>Platform for: </span><span class="fw-bolder">
                                Cryptocurrency, NFTs and Equities
                                powered by unexplored signals and multi-factor ratings.
                            </span>
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--/ Knowledge base Jumbotron -->
    <!-- Knowledge base -->
    <section id="knowledge-base-content">
        <div class="row kb-search-content-info match-height">

            <!-- Scan the Market -->
            <div class="col-lg-4 col-md-12 col-12 kb-search-content">
                <div class="card about-card-body">
                    <img src="assets/images/pages/stock.png" class="card-img-top" alt="knowledge-base-image" />
                    <div class="card-body text-center">
                        <h4 class="text-light">Scan the Market</h4>
                        <p class="mt-1 mb-0 text-light">Discover and keep up-to-date on daily top performing assets
                            and collections through Alpha Trend price and social monitors. Peak into macro
                            conditions driving overall market performance, and know if you’re in the green or red
                            market.</p>
                    </div>
                </div>
            </div>
            <!-- Individual Stock, Crypto and NFT Performance -->
            <div class="col-lg-4 col-md-12 col-12 kb-search-content">
                <div class="card about-card-body">
                    <img src="assets/images/pages/nft.png" class="card-img-top" alt="knowledge-base-image" />

                    <div class="card-body text-center">
                        <h4 class="text-light">Individual Stock, Crypto and NFT Performance</h4>
                        <p class="mt-1 mb-0 text-light">
                            Analyze each asset closely by monitoring price performance historically and real-time.
                            Overlay price with Alpha Trend signals to observe and capture hidden ALPHAS.
                            For NFT collections: We break down the market between pre-mint and marketplace signals.
                            Understand the hype signals driving the demand of collections, or peak into performance
                            during daily flips.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Alpha Trend For Growth -->
            <div class="col-lg-4 col-md-12 col-12 kb-search-content">
                <div class="card about-card-body">
                    <img src="assets/images/pages/crypto.png" class="card-img-top" alt="knowledge-base-image" />
                    <div class="card-body text-center">
                        <h4 class="text-light">Alpha Trend For Growth</h4>
                        <p class="mt-1 mb-0 text-light">
                            Build your own portfolios based on Alpha Trend’s classification of signals, or leverage
                            Alpha Trend Scoring models for more guidance on smart investments for individual assets.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Knowledge base ends -->
</div>